import Cookies from 'js-cookie';

export interface CookieAttributes {
  expires?: number | Date;
  path?: string;
  domain?: string;
  secure?: boolean;
  sameSite?: 'strict' | 'Strict' | 'lax' | 'Lax' | 'none' | 'None';
}

export const setCookie = (name: string, value: string, option?: CookieAttributes) => {
  Cookies.set(name, value, option);
};

export const getAllCookies = () => {
  return Cookies.get();
};

export const getCookie = <T = string>(key: string): T => {
  return (Cookies.get(key) ?? '') as T;
};

export function removeCookie(name: string, domain?: string): void {
  Cookies.remove(name, { path: '/', secure: true, domain });
}
